import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import StripeFields from 'Components/Front/StripeFields';
import Loader from 'Pure/Loader';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
import { num } from 'Shared/utilities';
const MISSCONFIG_ERROR = ['Configuration de paiement non trouvée, ', 'veuillez réessayer ou nous contacter.'].join('');
const {
  app
} = window;

/**
 * @description Component handling stripe fields based on a booking id or
 * back pack company order
 *
 * @param { Object } props
 * @param { String } [props.booking]
 * @param { Object } [props.packorder]
 * @param { function } [props.onSuccess]
 * @param { Array } [props.bemit]
 *
 * @returns { React.ReactElement|null }
**/
export default function StripeForm(props) {
  const [state, setState] = useState('init');
  const [error, setError] = useState('');
  const [stripe_promise, setStripePromise] = useState(null);
  const [intent, setIntent] = useState(null);
  const [customer, setCustomer] = useState({});
  const [amount_to_pay, setAmountToPay] = useState(props.packorder ? num(props.packorder.total_amount_ttc) : num(window.localStorage.getItem('current_booking_price')));
  useEffect(() => {
    getPublicKey();
  }, []);
  if (!props.booking && !props.packorder) return null;
  if (error) return getFormStatus({
    error: error
  }, ['v2']);
  const loader = ['getting-public-key', 'getting-intent'].includes(state) ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['primary', props.packorder ? 'bg-back' : 'bg-white'],
    text: "Chargement"
  }) : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('c-stripe-form', props.bemit)
  }, state === 'form-init' && intent ? /*#__PURE__*/React.createElement(Elements, {
    key: props.booking || props.packorder?.id,
    stripe: stripe_promise,
    options: {
      clientSecret: intent
    }
  }, /*#__PURE__*/React.createElement(StripeFields, {
    intent: intent,
    customer: customer,
    onSuccess: handleSuccess,
    booking_id: props.booking,
    amount: amount_to_pay,
    packorder_id: props.packorder?.id
  })) : undefined, loader);
  async function getPublicKey() {
    setState('getting-public-key');
    try {
      var response = await ajaxRequest(action('GetStripePublicKey'), {
        data: props.packorder?.id ? {
          is__pack_order: true
        } : {
          booking_id: props.booking
        }
      });
    } catch (e) {
      const error_msg = e && typeof e.error === 'string' ? e.error : MISSCONFIG_ERROR;
      return setError(error_msg);
    }
    const pk = response?.pk || '';
    if (typeof pk === 'string' && pk) {
      setStripePromise(loadStripe(pk));
    }
    setState(pk ? 'getting-intent' : 'failed-getting-public-key');
    if (pk) getIntent();
  }
  async function getIntent() {
    setState('getting-intent');
    try {
      var response = await ajaxRequest(action('GetStripeIntent'), {
        data: props.packorder?.id ? {
          is__pack_order: true,
          packorder_id: props.packorder.id
        } : {
          booking_id: props.booking
        }
      });
    } catch (e) {
      console.error(e);
      const error = typeof e === 'string' ? e : typeof e?.error === 'string' ? e.error : undefined;
      if (error) {
        setError(error);
      }
    }
    const intent = response?.intent || '';
    const customer = response?.customer || {};
    if (intent && typeof intent === 'string') {
      setAmountToPay(num(response.price));
      setCustomer(customer);
      setIntent(intent);
      setState('form-init');
    } else {
      setState('failed-getting-intent');
    }
  }
  async function handleSuccess() {
    if (props.packorder?.id) {
      props.onSuccess?.();
    } else {
      app.navigateTo(URL('StripePaymentRedirectOK'));
    }
  }
}
